
import { SerializableObject } from '../../common-react/core';


/**
 * Labels for information
 */
export class Label extends SerializableObject {
  public locale: string;
  public title: string;
  public description: string;
}
